import React from "react";
const Pagination = ({
  currentPage,
  totalPages,
  onPageClick,
  onNextClick,
  onPreviousClick
}) => {
  const renderPagination = () => {
    let pagination = [];

    // First 3 pages
    for (let i = 1; i <= 3; i++) {
      pagination.push(<li key={i} className={`page-item ${i === currentPage ? "active" : ""}`}>
          <button className="page-link" onClick={() => onPageClick(i)} style={i === currentPage ? {
          borderRadius: "50%",
          width: "40px",
          textAlign: "center",
          backgroundColor: '#c5e2ff',
          boxShadow: "0 0 0",
          height: "40px",
          color: "#182230",
          border: "0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        } : {
          color: "#475467",
          fontSize: "14px",
          fontWeight: "500",
          border: "0",
          borderRadius: "50%",
          boxShadow: "0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}>
            {i}
          </button>
        </li>);
    }

    // Add dots after first 3 pages if needed
    if (currentPage > 4) {
      pagination.push(<li key="dots1" className="page-item disabled">
          <span className="mx-2" style={{
          borderRadius: "50%",
          border: "0px",
          color: "#475467"
        }}>...</span>
        </li>);
    }

    // Middle range dynamically calculated
    const startPage = Math.max(currentPage - 1, 4);
    const endPage = Math.min(currentPage + 1, totalPages - 2);
    for (let i = startPage; i <= endPage; i++) {
      if (i > 3 && i < totalPages - 2) {
        pagination.push(<li key={i} className={`page-item ${i === currentPage ? "active" : ""}`}>
            <button className="page-link" onClick={() => onPageClick(i)} style={i === currentPage ? {
            borderRadius: "50%",
            boxShadow: "0 0 0",
            width: "40px",
            textAlign: "center",
            backgroundColor: '#c5e2ff',
            height: "40px",
            color: "#182230",
            border: "0",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          } : {
            color: "#475467",
            boxShadow: "0 0 0",
            fontSize: "14px",
            fontWeight: "500",
            border: "0",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}>
              {i}
            </button>
          </li>);
      }
    }

    // Add dots before the last 3 pages if needed
    if (currentPage < totalPages - 3) {
      pagination.push(<li key="dots2" className="page-item disabled">
          <span style={{
          border: "50%",
          color: "#475467"
        }} className="mx-2">...</span>
        </li>);
    }

    // Last 3 pages
    for (let i = totalPages - 2; i <= totalPages; i++) {
      if (i >= 4) {
        pagination.push(<li key={i} className={`page-item ${i === currentPage ? "active" : ""}`}>
            <button className="page-link" onClick={() => onPageClick(i)} style={i === currentPage ? {
            borderRadius: "50%",
            boxShadow: "0 0 0",
            width: "40px",
            textAlign: "center",
            backgroundColor: '#c5e2ff',
            height: "40px",
            color: "#182230",
            border: "0",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          } : {
            color: "#475467",
            boxShadow: "0 0 0",
            fontSize: "14px",
            fontWeight: "500",
            border: "0",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}>
              {i}
            </button>
          </li>);
      }
    }
    return pagination;
  };
  return <div className="d-none d-sm-block" data-sentry-component="Pagination" data-sentry-source-file="Pagination.jsx">
      <ul className="pagination justify-content-between pt-4" style={{
      borderTop: "1px solid #EAECF0"
    }}>
        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
          <button className="page-link d-flex align-items-center gap-2" onClick={onPreviousClick} disabled={currentPage === 1} // Disable Previous button on first page
        >
            <img src="https://d2nnrpx7gk2my2.cloudfront.net/files/6706ca407c17160008fb2782/arrow-left.svg" alt="" />
            Previous
          </button>
        </li>
        <div className="d-flex gap-1 align-items-center">{renderPagination()}</div>

        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
          <button className="page-link d-flex align-items-center gap-2" onClick={onNextClick} disabled={currentPage === totalPages} // Disable Next button on last page
        >
            Next{" "}
            <img src="https://d2nnrpx7gk2my2.cloudfront.net/files/6706c9f97c17160008fb2780/arrow-right.svg" alt="" />
          </button>
        </li>
      </ul>
      <style jsx>{`
          .pagination .page-item .page-link {
            color: #555;
            border: 0;
          }

          .pagination .page-item .page-link:hover {
            background-color: #e0e0e0;
          }
          .pagination .page-item .page-link:focus {
            box-shadow:0 0 0 !important;
          }

          .pagination .page-item.disabled .page-link {
            color: #525252;
            font-weight: 600;
            font-size: 14px;
            border:0px !important;
            cursor: not-allowed; /* Disable cursor for disabled state */
          }

          .pagination .page-item .page-link {
            border: none;
            font-size: 14px;
            font-weight: 600;
          }
          .page-link{
            border-radius: 50% !important;
          }
          .page-link:hover {
              z-index: 2;
              color: #0a58ca;
              background-color: transparent !important;
              border-color: transparent !important;
              border-radius: 0 !important;
              border: 0 !important;
          }
          .page-link:focus {
              border: 0 !important;
              box-shadow:0 0 0 !important ;
          }
          .page-link:focus{
             box-shadow:0 0 0 !important ;
          }
        

          .pagination {
            display: flex;
            justify-content: center;
            padding-left: 0;
            list-style: none;
          }

          .page-link:focus {
            background-color: #fff;
          }
          .page-link {
              padding: .375rem 0rem !important;
          }
           .page-item.disabled .page-link {
            border:0px !important;
          }
         .page-link {
             border:0px solid !important;
          }
        `}</style>
    </div>;
};
export default Pagination;